import artifact from '$houdini/artifacts/UpdateDashboardChart'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateDashboardChartStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
